import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { MIN_HEIGHT_EDITABLE_ITEM_PLAN_SIZE_MM } from '../../Constants';
/**
 * アイテムのサイズ変更ダイアログ
 * 対象：住宅設備、家具、エクステリア
 */
export default class ItemSizeChangeDialog extends Dialog {
    targetItem: marietta.webcad.item.MonicaObject;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);
      // ターゲットのお部屋
      this.targetItem = marietta.webcad.WebCADGlobal.itemManager.currentItem;

      // ダイアログのコンテンツ生成
      const id = 'itemSizeChangeDialog';
      const title = 'アイテムサイズの変更';
      let contents = '<div class="dialogItemSizeChange">\n';
      contents += '<table>\n';
      contents += '<tbody>\n';
      contents += '<tr>\n';
      contents += '<td><label>幅</label></td>\n';
      contents += '<td><input type="tel" id="itemSizeChangeDialog_inputWidth" data-motosize="0"></td>\n';
      contents += '<td>mm</td>\n';
      contents += '</tr>\n';
      contents += '<tr>\n';
      contents += '<td><label>奥</label></td>\n';
      contents += '<td><input type="tel" id="itemSizeChangeDialog_inputHeight" data-motosize="0"></td>\n';
      contents += '<td>mm</td>\n';
      contents += '</tr>\n';
      contents += '</tbody>\n';
      contents += '</table>\n';
      contents += '</div>';
      let footer = '<button id="itemSizeChangeDialogDone">ＯＫ</button>';
      footer += '<button id="btnSizeChangeClose">キャンセル</button>';
      this.createDialog(id, title, contents, footer);

      // ダイアログの初期設定
      this.initMe();

      // イベント設定
      document.getElementById('itemSizeChangeDialogDone').addEventListener('click', this.okBtnClickHandler);
      document.getElementById('itemSizeChangeDialog_inputWidth').addEventListener('change', this.varidateParam);
      document.getElementById('itemSizeChangeDialog_inputHeight').addEventListener('change', this.varidateParam);

      document.getElementById('btnSizeChangeClose').addEventListener('click', () => {
        marietta.webcad.WebCADGlobal.removeDialog();
      });
    }

    /**
     * ダイアログの初期設定
     */
    initMe() {
      this.getItemSize();
    }

    /**
     * アイテムのサイズをinputボックスに反映
     */
    getItemSize() {
      (<HTMLInputElement>document.getElementById('itemSizeChangeDialog_inputWidth')).value = (this.targetItem.itemInfo.widthmm).toString();
      (<HTMLInputElement>document.getElementById('itemSizeChangeDialog_inputWidth')).setAttribute('data-motosize', this.targetItem.itemInfo.widthmm.toString());
      (<HTMLInputElement>document.getElementById('itemSizeChangeDialog_inputHeight')).value = (this.targetItem.itemInfo.heightmm).toString();
      (<HTMLInputElement>document.getElementById('itemSizeChangeDialog_inputHeight')).setAttribute('data-motosize', this.targetItem.itemInfo.heightmm.toString());
    }

    /**
     * 入力された内容を制限する
     */
    varidateParam = (e) => {
      const tar = (e.currentTarget);
      const val:any = (tar).value;
      // 全て半角数値でなければ、値を元に戻す
      if (!val.match(/^[0-9]+$/)) {
        tar.value = (!Number.isNaN((tar).getAttribute('data-motosize')) ? (tar).getAttribute('data-motosize') : 0);
      } else if ((tar).value > marietta.webcad.WebCADGlobal.MAX_SIZE_CHANGE_MONICA) {
        (tar).value = (marietta.webcad.WebCADGlobal.MAX_SIZE_CHANGE_MONICA);
      } else if (this.targetItem.isHeightEditableItem() && Number(tar.value) < MIN_HEIGHT_EDITABLE_ITEM_PLAN_SIZE_MM) {
        // 下限は住設・家具だけ。エクステリア等は従来どおり制限しない
        tar.value = MIN_HEIGHT_EDITABLE_ITEM_PLAN_SIZE_MM.toString();
      }
    }

    /**
     * OKボタンが押された
     */
    okBtnClickHandler = () => {
      this.updateItemSize();
      marietta.webcad.WebCADGlobal.removeDialog();
    }

    /**
     * 入力されたサイズをカレントアイテムへ反映
     */
    updateItemSize = () => {
      if (marietta.webcad.WebCADGlobal.itemManager.currentItem === null) return;

      let sizeW: number = parseFloat((<HTMLInputElement>document.getElementById('itemSizeChangeDialog_inputWidth')).value);
      let sizeH: number = parseFloat((<HTMLInputElement>document.getElementById('itemSizeChangeDialog_inputHeight')).value);

      // mmからpxに変換
      sizeW = marietta.webcad.util.WebCADUtil.convertMMToPix(sizeW);
      sizeH = marietta.webcad.util.WebCADUtil.convertMMToPix(sizeH);

      marietta.webcad.WebCADGlobal.itemManager.currentItem.changeSize(sizeW, sizeH, true);

      // アイテムコントローラー更新
      const currntItem = marietta.webcad.WebCADGlobal.itemManager.currentItem;
      marietta.webcad.WebCADGlobal.itemManager.currentItem = currntItem;

      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }
}
